const t = (o = "old") => o === "new" ? "#46DE46" : "#CB6B42";
export {
  t as getStarsDefaultColor
};
